import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { Prato } from '../models/prato.model';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root',
})
export class PratoService {
  constructor(private http: HttpClient, public socket: Socket) {}

  progressoImportadorPratos = this.socket.fromEvent('progressoImportadorPratos');

  async incluirFilaCriacao(body: any): Promise<Prato[]> {
    return await lastValueFrom(
      this.http.post<Prato[]>(
        `${environment.apiUrl}/pratos/incluir-fila-criacao`,
        body
      )
    ).catch((err) => {
      throw Error(err);
    });
  }
  
  async buscarPratosPorRestaurante(restauranteId: string){
    return await lastValueFrom(
      this.http.get<Prato[]>(
        `${environment.apiUrl}/pratos/restaurante/${restauranteId}`,
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async buscarPratoPorId(pratoId: string){
    return await lastValueFrom(
      this.http.get<Prato>(
        `${environment.apiUrl}/pratos/${pratoId}`,
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async criar(body: Prato): Promise<Prato> {
    return await lastValueFrom(
      this.http.post<Prato>(`${environment.apiUrl}/pratos`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async atualizar(id: string, body: Prato): Promise<Prato> {
    return await lastValueFrom(
      this.http.patch<Prato>(`${environment.apiUrl}/pratos/${id}`, body)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async ativar(id: string): Promise<Prato> {
    return await lastValueFrom(
      this.http.patch<Prato>(
        `${environment.apiUrl}/pratos/ativar/${id}`,
        {}
      )
    ).catch((err) => {
      throw err.error.error
    });
  }

  async desativar(id: string): Promise<Prato> {
    return await lastValueFrom(
      this.http.patch<Prato>(
        `${environment.apiUrl}/pratos/desativar/${id}`,
        {}
      )
    ).catch((err) => {
      throw err.error.error
    });
  }

  async remover(id: string): Promise<Prato> {
    return await lastValueFrom(
      this.http.delete<Prato>(`${environment.apiUrl}/pratos/${id}`)
    ).catch((err) => {
      throw err.error.error
    });
  }

  async buscarTagsAi(id: string): Promise<any> {
    return await lastValueFrom(
      this.http.get<any>(`${environment.apiUrl}/pratos/buscar-tags-ai/${id}`)
    ).catch((err) => {
      throw err.error.error;
    });
  }
}
